import {StyleSheet} from 'react-native';

import {cloudLight, cloudLighter} from '/theme/color/on.color';
import {getFontFamily} from '/util/text.util';

export const styles = StyleSheet.create({
  base: {},
  personRow: {
    paddingVertical: 20,
    flexDirection: 'row',
    alignItems: 'center',
  },
  personRowWithBorder: {
    borderTopWidth: 1,
    borderTopColor: cloudLight,
  },
  avatarColumn: {
    marginRight: 8,
  },
  infoColumn: {
    marginLeft: 8,
  },
  filledAvatar: {},
  emptyAvatar: {
    width: 40,
    minHeight: 40,
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: cloudLighter,
    borderColor: cloudLight,
    borderWidth: 2,
    borderStyle: 'dotted',
    borderRadius: 99999,
  },
  vacantName: {},
  // @ts-expect-error TS(2322): Type '{ fontFamily: string; fontWeight: string | u... Remove this comment to see the full error message
  personName: {
    ...getFontFamily('bold'),
  },
  personStats: {
    marginTop: 10,
  },
  seeMore: {
    borderTopWidth: 1,
    borderTopColor: cloudLight,
    minHeight: 52,
  },
  seeMoreContent: {
    width: '100%',
    height: '100%',
    alignItems: 'center',
    justifyContent: 'center',
  },
});
